<template>
  <el-form :model="targetingForm" label-width="180px" ref="target" :rules="rules">
    <slot name="targetname">
      <el-form-item label="项目组名称">
        <el-input v-model="targetingForm.name" style="width: 320px"></el-input>
      </el-form-item>
    </slot>
    <template v-if="adMarketingSceneType.version3 || adMarketingSceneType.version_smart">
      <el-form-item label="手动定向模式" v-if="adMarketingSceneType.version3">
        <template v-if="isEditMode">
          <span style="color: red; font-size: 12px">&emsp;注意：切换定向模式前往媒体后台！</span>
        </template>
        <template v-else>
          <el-switch v-model="planForm.smart_targeting_mode"></el-switch>
          <span style="margin-left: 8px; font-size: 12px; color: #909399">{{ planForm.smart_targeting_mode ? '手动定向已开启，当前为手动定向模式' : '手动定向已关闭，当前为智能定向模式' }}</span>
        </template>
      </el-form-item>

      <el-form-item label="人群包">
        <el-radio-group v-model="targetingForm.audienceType">
          <el-radio-button ghost :label="AUDIENCES_TYPE.NO_LIMIT">不限</el-radio-button>
          <el-radio-button ghost :label="AUDIENCES_TYPE.LIMITED">定向或排除人群</el-radio-button>
        </el-radio-group>
        <div v-show="targetingForm.audienceType === AUDIENCES_TYPE.LIMITED" style="margin-top: 6px" v-loading="audienceLoading">
          <AudiencesTable
            v-if="showAudiencesTable"
            v-model="populations"
            :data="audiencesData"
            :accounts="adAccounts"
            @account-change="getAudienceData"
          >
            <el-table-column prop="userCount" width="90" label="覆盖数量"> </el-table-column>
          </AudiencesTable>
          <div v-else>请先选择账号</div>
        </div>
      </el-form-item>
    </template>

    <el-form-item label="地域" prop="regionType" v-if="adMarketingSceneType.version3">
      <el-radio-group v-model="targetingForm.regionType">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">按省市</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px" v-if="targetingForm.regionType === 1">
        <CascaderSelector
          v-model="targetingForm.region"
          :props="{ multiple: true, value: 'id', label: 'value' }"
          :options="filterdCityData"
        />

        <div>
          <el-checkbox-group v-model="targetingForm.locationTypes" :disabled="locationTypeDisabled">
            <el-checkbox label="RECENTLY_IN">近期在这里的人</el-checkbox>
            <el-checkbox label="LIVE_IN">常住这里的人</el-checkbox>
            <el-checkbox label="TRAVEL_IN">旅行到这里的人</el-checkbox>
            <el-checkbox label="VISITED_IN">去过这里的人</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-form-item>

    <el-form-item label="性别">
      <el-radio-group v-model="targetingForm.gender">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost label="MALE">男</el-radio-button>
        <el-radio-button ghost label="FEMALE">女</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="年龄">
      <el-radio-group v-model="targetingForm.age">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="item.value" v-for="(item, index) in AGES" :key="index">{{ item.label }}</el-radio-button>
        <el-radio-button ghost :label="1">自定义</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px; width: 668px" v-if="targetingForm.age === 1">
        <p style="font-size: 12px">自定义年龄段：{{ ageRangeText }}</p>

        <!-- 当批量失败修改时，新建广告成功后不能再修改 -->
        <el-slider
          v-model="targetingForm.ageRange"
          :disabled="!!projectInstance.adBlockModifyForbid"
          :marks="{ 14: '14岁', 66: '66岁及以上' }"
          range
          show-stops
          :min="14"
          :max="66"
          :format-tooltip="(v) => (v === 66 ? '66岁及以上' : `${v}岁`)"
        >
        </el-slider>
      </div>
    </el-form-item>

    <el-form-item label="微信再营销" v-if="adMarketingSceneType.version_search || adMarketingSceneType.version_smart">
      <MixedElCheckBoxGroup v-model="targetingForm.wechatAdBehaviorType">
        <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
        <el-checkbox-button ghost label="ACTIONS">再营销</el-checkbox-button>
        <el-checkbox-button ghost label="EXCLUDED_ACTIONS">排除再营销</el-checkbox-button>
      </MixedElCheckBoxGroup>
      <WechatAdBehavior :behavior.sync="targetingForm.wechatAdBehavior" :type="targetingForm.wechatAdBehaviorType"></WechatAdBehavior>
    </el-form-item>

    <el-form-item label="手机品牌" prop="deviceType" v-if="adMarketingSceneType.version3">
      <el-radio-group v-model="targetingForm.deviceType">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">按手机品牌</el-radio-button>
      </el-radio-group>
      <div style="margin-top: 6px" v-if="targetingForm.deviceType === 1">
        <CascaderSelector
          v-model="targetingForm.device"
          :props="{ multiple: true, value: 'id', label: 'value' }"
          :options="deviceBrandData"
        />

        <div>
          <el-checkbox v-model="targetingForm.excludeDevice">排除所选设备的用户</el-checkbox>
        </div>
      </div>
    </el-form-item>

    <el-form-item label="系统版本" prop="osType">
      <el-radio-group v-model="targetingForm.osType">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost :label="1">选择版本</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 6px" v-if="targetingForm.osType === 1">
        <CascaderSelector
          v-model="targetingForm.version"
          :props="{ multiple: true, value: 'id', label: 'value' }"
          :options="deviceVersionData"
        />
      </div>
    </el-form-item>

    <template v-if="adMarketingSceneType.version3">
      <el-form-item label="网络">
        <MixedElCheckBoxGroup v-model="targetingForm.network">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost v-for="n in NETWORKS" :key="n.value" :label="n.label">{{ n.value }}</el-checkbox-button>
        </MixedElCheckBoxGroup>
      </el-form-item>

      <el-form-item label="游戏消费能力">
        <MixedElCheckBoxGroup v-model="targetingForm.game_consumption_level">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost label="HIGH">高</el-checkbox-button>
          <el-checkbox-button ghost label="NORMAL">普通</el-checkbox-button>
        </MixedElCheckBoxGroup>

        <!-- <el-radio-button ghost label="HIGH">高</el-radio-button>
        <el-radio-button ghost label="NORMAL">普通</el-radio-button> -->
      </el-form-item>

      <el-form-item label="微信再营销">
        <MixedElCheckBoxGroup v-model="targetingForm.wechatAdBehaviorType">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost label="ACTIONS">再营销</el-checkbox-button>
          <el-checkbox-button ghost label="EXCLUDED_ACTIONS">排除再营销</el-checkbox-button>
        </MixedElCheckBoxGroup>
        <WechatAdBehavior :behavior.sync="targetingForm.wechatAdBehavior" :type="targetingForm.wechatAdBehaviorType"></WechatAdBehavior>
      </el-form-item>

      <el-form-item label="设备价格">
        <MixedElCheckBoxGroup v-model="targetingForm.devicePrice">
          <el-checkbox-button ghost :label="0">不限</el-checkbox-button>
          <el-checkbox-button ghost :label="price.value" v-for="price in DEVICE_PRICES" :key="price.value">
            {{ price.label }}
          </el-checkbox-button>
        </MixedElCheckBoxGroup>
      </el-form-item>
    </template>

    <el-form-item label="排除已转化用户">
      <el-radio-group v-model="targetingForm.excluded_converted_audience.excluded_dimension">
        <el-radio-button ghost :label="0">不限</el-radio-button>
        <el-radio-button ghost label="EXCLUDED_DIMENSION_CAMPAIGN">同计划</el-radio-button>
        <el-radio-button ghost label="EXCLUDED_DIMENSION_UID">同账号计划</el-radio-button>
        <el-radio-button ghost label="EXCLUDED_DIMENSION_BUSINESS_MANAGER">同商务管家计划</el-radio-button>
        <el-radio-button ghost label="EXCLUDED_DIMENSION_COMPANY_ACCOUNT">同主体计划</el-radio-button>
        <el-radio-button ghost label="EXCLUDED_DIMENSION_APP">同应用</el-radio-button>
      </el-radio-group>

      <div class="custom-switch" v-if="targetingForm.excluded_converted_audience.excluded_dimension !== 0">
        <div class="switch">
          <el-switch v-model="targetingForm.excludeCustom"></el-switch>
          <span>&ensp;自定义转化行为</span>
        </div>
        <el-select
          v-if="targetingForm.excludeCustom"
          v-model="targetingForm.excluded_converted_audience.conversion_behavior_list"
          style="width: 280px; margin-top: 6px"
          multiple
          :multiple-limit="2"
          @change="onBehaviorChange"
        >
          <el-option v-for="item in CONVERSION_BEHAVIOR_LIST" :key="item.label" :value="item.value" :label="item.label"> </el-option>
        </el-select>

        <div v-if="targetingForm.excludeCustom">
          <div style="font-size: 13px">
            转化时间区间
            <el-tooltip
              class="item"
              effect="dark"
              content="设置排除已转化行为以及转化时间区间，计划不会曝光给所选范围内已转化的用户。系统将自动以当前计划选择的优化目标作为此定向的转化行为；该定向仅可选择oCPC、oCPM、oCPA 出价方式，若选择自定义转化行为则不限制出价方式。"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <el-radio-group v-model="targetingForm.excluded_converted_audience.excluded_day">
            <el-radio-button ghost :label="EXCLUDED_DAY.ONE_DAY">当日</el-radio-button>
            <el-radio-button ghost :label="EXCLUDED_DAY.SEVEN_DAY">7日</el-radio-button>
            <el-radio-button ghost :label="EXCLUDED_DAY.ONE_MONTH">1个月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import MixedElCheckBoxGroup from '@/components/check-box-group/index.vue'
import WechatAdBehavior from './wechat-ad-behavior/index.vue'
import AudiencesTable from '@/views/edit/kuaishou/components/audiences-table/index.vue'
import CascaderSelector from '@/components/cascader-select/index.vue'
import androidVersion from '@/data/tencent/android_version'
import iosVersion from '@/data/tencent/ios_version'

import { SITE_ENUM, WECHAT_SITES } from '../../model/siteset/siteset-const.js'
import {
  AUDIENCES_TYPE,
  AGES,
  NETWORKS,
  DEVICE_PRICES,
  CONVERSION_BEHAVIOR_LIST,
  EXCLUDED_DAY
} from '@/views/create/gdt/model/targeting-const.js'
import { AD_MARKETING_SCENE } from '@/views/create/gdt/model/project-const.js'
import { getAudience, getDevice } from '@/api/tencent.model'
import makeTargetingRules from '../../model/targeting-rules.js'

export default {
  inject: ['projectInstance'],
  props: {
    value: {
      type: Object
    },
    adMarketingScene: {
      type: String
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MixedElCheckBoxGroup,
    WechatAdBehavior,
    AudiencesTable,
    CascaderSelector
  },
  data() {
    return {
      AGES,
      AUDIENCES_TYPE,
      NETWORKS,
      DEVICE_PRICES,
      CONVERSION_BEHAVIOR_LIST,
      EXCLUDED_DAY,
      rules: makeTargetingRules.call(this),
      audienceLoading: false,
      cityData: [],
      deviceBrandData: [],
      audiencesData: [] // 人群包列表
    }
  },
  created() {
    this.getInitPageData()
    this.initEventBus()
  },
  computed: {
    targetingForm: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    adAccounts() {
      return this.projectInstance.adAccounts
    },
    siteSets() {
      return this.planForm.siteSet || []
    },
    isAutomaticSiteEnabled() {
      return this.planForm.automatic_site_enabled
    },
    // 包含视频号版位
    hasChannelSiteset() {
      return this.siteSets.includes(SITE_ENUM.CHANNELS)
    },

    /**
     * @description: 是否微信流量
     */
    isWechatStream() {
      return WECHAT_SITES.some((s) => this.projectInstance.planForm.siteSet.includes(s))
    },
    // 包含视频号版位 或 自动版位时禁用
    locationTypeDisabled() {
      return this.hasChannelSiteset || this.isAutomaticSiteEnabled
    },
    /**
     * @description: 自动版位、微信流量不显示台湾、香港、澳门
     */
    filterdCityData() {
      if (this.isWechatStream || this.isAutomaticSiteEnabled) {
        const regions = this.cityData.filter((c) => {
          c.children = c.children.filter((child) => !['台湾省', '香港特别行政区', '澳门特别行政区'].includes(child.value))
          return c.value === '中国'
        })
        return regions
      }
      return this.cityData
    },
    showAudiencesTable() {
      return Object.values(this.populations).length > 0
    },
    populations: {
      get() {
        return this.value.populations
      },
      set(vals) {
        const { accountId } = vals
        const newForm = this.targetingForm
        newForm.populations = {
          ...newForm.populations,
          [accountId]: vals
        }

        this.targetingForm = newForm
      }
    },
    planForm() {
      return this.projectInstance.planForm
    },
    /**
     * @description: 自定义年龄段滑块文字提示
     */
    ageRangeText() {
      let [start, end] = this.targetingForm.ageRange
      if (end === 66) {
        end = '66岁及以上'
      } else {
        end = `${end}岁`
      }
      return `${start}岁 - ${end}`
    },

    /**
     * @description: 根据应用平台返回系统版本数据
     */
    deviceVersionData() {
      const ch_platform_id = this.planForm.ch_platform_id
      // 对应的平台返回对应的系统版本，小程序平台返回安卓和ios
      return [[], androidVersion, iosVersion, [...androidVersion, ...iosVersion]][ch_platform_id]
    },
    pageStates() {
      return this.projectInstance.pageStates
    },

    adMarketingSceneType() {
      return {
        version3: this.adMarketingScene === AD_MARKETING_SCENE.VERSION_3,
        version_smart: this.adMarketingScene === AD_MARKETING_SCENE.VERSION_SMART,
        version_search: this.adMarketingScene === AD_MARKETING_SCENE.VERSION_SEARCH
      }
    }
  },
  watch: {
    'planForm.ch_platform_id'() {
      // 当新建流程时，切换应用平台时，清空系统版本
      if (this.pageStates?.isCreate) {
        this.targetingForm = {
          ...this.targetingForm,
          version: []
        }
      }
    }
  },
  methods: {
    /**
     * @description: 注册事件总线
     * @description: src/views/create/gdt/components/plan/siteset.vue在此文件中触发
     * @return {*}
     */
    initEventBus() {
      // sitesetChange 监听版位变化
      this.$bus.$on('sitesetChange', this.onSitesetChange)
      // automaticSiteEnabledChange 监听开启自动版位变化
      this.$bus.$on('automaticSiteEnabledChange', this.onAutomaticSiteEnabledChange)
    },
    onSitesetChange() {
      if (this.isWechatStream) {
        this.$set(this.targetingForm, 'region', [])
      }
      if (this.siteSets.includes(SITE_ENUM.CHANNELS)) {
        this.$set(this.targetingForm, 'locationTypes', ['LIVE_IN'])
      }
    },
    /**
     * @description: 切换到自动版位时，自动地域为【常住】
     * @return {*}
     */
    onAutomaticSiteEnabledChange() {
      if (this.isAutomaticSiteEnabled) {
        this.$set(this.targetingForm, 'locationTypes', ['LIVE_IN'])
      }
    },
    /**
     * @description: 切换账号获取人群包定向数据
     * @param {*} ad_account_id
     * @return {*}
     */
    getAudienceData(ad_account_id) {
      if (!ad_account_id) return
      this.audienceLoading = true
      getAudience({ ad_account_id }).then((data) => {
        this.audiencesData = data.map((au) => ({
          ...au,
          check: null,
          includesDisabled: false,
          excludesDisabled: false,
          groupId: au.audience_id,
          groupName: au.name,
          userCount: au.user_count
        }))
        this.audienceLoading = false
      })
    },
    /**
     * @description: 最少要选择一个
     * @return {*}
     */
    onBehaviorChange(list) {
      if (!list?.length) {
        this.$nextTick(() => {
          const excluded_converted_audience = this.targetingForm.excluded_converted_audience
          excluded_converted_audience.conversion_behavior_list = ['OPTIMIZATIONGOAL_FOLLOW']
          this.targetingForm = {
            ...this.targetingForm,
            excluded_converted_audience
          }

          this.$Message.warning('请至少选择一个行为')
        })
      }
    },
    getInitPageData() {
      const [ad_account_id] = this.planForm.accounts

      this.getAudienceData(ad_account_id)
      getDevice({ ad_account_id }).then((data) => {
        // 递归修改数据结构
        const loop = (list) => {
          return list.map((res) => {
            const item = {
              id: Number(res.id),
              key: Number(res.id),
              value: res.value
            }

            if (res.children?.length) {
              item.children = loop(res.children)
            }
            return item
          })
        }

        this.deviceBrandData = loop(data)
      })

      // 城市列表数据
      fetch('/data/tencent_region.json')
        .then((res) => res.json())
        .then((cities) => (this.cityData = cities))
    },
    formValidate() {
      return this.$refs.target.validate()
    },
    clearValidate() {
      this.$refs.target.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-switch {
  margin-top: 6px;

  .switch {
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
::v-deep .el-slider__marks-text {
  width: 40px;
  white-space: nowrap;
  font-size: 12px;
  margin-top: 6px;
}
</style>
